export default "__VITE_ASSET__V_W0UkAD__"